import Vue from 'vue';

import PxAvisoPlataformaFornecedor from './PxAvisoPlataformaFornecedor.vue';
import PxAvisoPlataformaFornecedorSimple from './PxAvisoPlataformaFornecedorSimple.vue';
import PxBannerGestao from './PxBannerGestao.vue';

Vue.component('PxAvisoPlataformaFornecedor', PxAvisoPlataformaFornecedor);
Vue.component('PxAvisoPlataformaFornecedorSimple', PxAvisoPlataformaFornecedorSimple);
Vue.component('PxBannerGestao', PxBannerGestao);
